<app-nav></app-nav>

<main class="main-content">
  <router-outlet></router-outlet>
</main>
